const localStorageManager = (key) => {
  return ({
    get: () => window.localStorage.getItem(key),
    set: token => window.localStorage.setItem(key, token),
    clear: () => window.localStorage.removeItem(key),
  })
}
export const tokenStorage = localStorageManager('PP_auth')
export const subdirectoryStorage = localStorageManager('PP_sd')
